export const cleanCommaSeparatedEmailAddressString = commaSeparatedEmailAddress => {
  if (!commaSeparatedEmailAddress) {
    return ''; // Handle null, undefined, or empty input gracefully
  }

  return commaSeparatedEmailAddress
    .split(',')
    .map(email => email.trim()) // Remove leading/trailing whitespace from each email
    .filter(email => email) // Remove empty strings (e.g., from extra commas)
    .join(',');
};
